import { Globe } from "lucide-react";
import { useLocale } from "../hooks/useLocale";
import { SUPPORTED_LOCALES, type Locale } from "../i18n";
import { useTranslation } from "react-i18next";

const LABELS: Record<Locale, string> = {
  fr: "FR",
  en: "EN",
};

// Switcher discret en pied de sidebar : icône globe + ligne de boutons
// FR | EN. Le choix est appliqué immédiatement (i18next change de langue
// in-place, React re-render le tree) et sauvé en localStorage.
export function LanguageSwitcher(): JSX.Element {
  const { locale, setLocale } = useLocale();
  const { t } = useTranslation();

  return (
    <div className="px-3 py-2">
      <div className="flex items-center gap-2 text-xs text-ink-500 mb-1.5">
        <Globe className="size-3.5" />
        <span>{t("language.label")}</span>
      </div>
      <div className="flex items-center gap-1">
        {SUPPORTED_LOCALES.map((l) => {
          const active = locale === l;
          return (
            <button
              key={l}
              onClick={() => setLocale(l)}
              className={`flex-1 px-2 py-1 rounded-md text-xs font-medium transition-colors ${
                active
                  ? "bg-velvet-600/20 text-velvet-300 border border-velvet-600/40"
                  : "text-ink-400 hover:text-white hover:bg-ink-700/50 border border-transparent"
              }`}
              aria-label={t(`language.${l}`)}
              aria-pressed={active}
            >
              {LABELS[l]}
            </button>
          );
        })}
      </div>
    </div>
  );
}
